import { render, staticRenderFns } from "./ListContratoPage.vue?vue&type=template&id=c6f13c42"
import script from "./ListContratoPage.vue?vue&type=script&lang=js"
export * from "./ListContratoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports